// Reminder: Add this to RootReducer.jsx
import Immutable from 'immutable';
import {
  SET_BLOCKS,
  UPDATE_BLOCK,
  SET_BLOCKDATA,
  SET_SETUPDATA,
  UPDATE_SETUPDATA,
  SET_USERDATA,
  DELETE_BLOCKS,
  SET_BLOCK_PROGRESS,
  UPDATE_BLOCK_PROGRESSSETTINGS,
  UPDATE_BLOCK_SHARINGSETTINGS,
  UPDATE_BLOCK_GROUPWORKSETTINGS,
  UPDATE_PORTFOLIO_SETTINGS,
  MOVE_BLOCK_START,
} from './actions';
import { BLOCKPAGE_DATA_LOADED_SUCCESS } from '../BlockPageUI/actions';
import { PageContext } from '../../web/containers/BlockPage/consts';

// {blockId} > blockData
const DEFAULT_STATE = Immutable.Map();

const setBlocks = (state, blocks) => {
  let newState = state;
  blocks.forEach((block) => {
    // Set default data
    const key = `block-${block.id}`;

    newState = newState.set(
      key,
      newState.get(key, Immutable.Map()).merge(Immutable.fromJS(block))
    );
  });
  return newState;
};

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function Blocks(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_BLOCKS: {
      return setBlocks(state, action.blocks);
    }
    case BLOCKPAGE_DATA_LOADED_SUCCESS: {
      const {
        blockData: { blockList },
        viewedFrom,
      } = action;
      if (viewedFrom !== PageContext.HISTORY) {
        return setBlocks(state, blockList);
      } else {
        return state;
      }
    }
    case UPDATE_BLOCK: {
      const key = `block-${action.blockID}`;
      return state.mergeIn([key], Immutable.fromJS(action.changes));
    }
    case SET_BLOCK_PROGRESS: {
      // Value coming in is 0.0-1.0
      const key = `block-${action.blockID}`;
      return state.setIn([key, 'assessment', 'progress'], action.value);
    }
    case UPDATE_BLOCK_PROGRESSSETTINGS: {
      const key = `block-${action.blockID}`;
      const newState = state.mergeIn(
        [key, 'progressSettings'],
        Immutable.fromJS(action.changes)
      );
      const isProgressContributor =
        newState.getIn([key, 'progressSettings', 'choiceIndex'], 0) > 0;
      return newState.setIn(
        [key, 'isProgressContributor'],
        isProgressContributor
      );
    }
    case UPDATE_BLOCK_SHARINGSETTINGS: {
      const key = `block-${action.blockID}`;

      let newState = state;
      newState = newState.setIn(
        [key, 'sharing', 'accessType'],
        action.accessType
      );
      newState = newState.setIn([key, 'sharing', 'scheme'], action.scheme);
      newState = newState.setIn(
        [key, 'sharing', 'groups'],
        Immutable.fromJS(action.groups)
      );
      newState = newState.setIn(
        [key, 'sharing', 'condition'],
        Immutable.fromJS(action.condition)
      );
      newState = newState.setIn(
        [key, 'sharing', 'revealAfter'],
        action.revealTime
      );

      return newState;
    }

    case UPDATE_BLOCK_GROUPWORKSETTINGS: {
      const { blockID, isGroupWorkActivity, groupType } = action;
      const key = `block-${blockID}`;

      return state.mergeIn([key, 'groupWorkSettings'], {
        isGroupWorkActivity,
        groupType,
      });
    }

    case UPDATE_PORTFOLIO_SETTINGS: {
      const { blockID, isPortfolioEnable } = action;
      const key = `block-${blockID}`;

      return state.mergeIn(
        [key, 'portfolioSettings', 'portfolioDefaultOption'],
        isPortfolioEnable
      );
    }
    // Replaces block data
    case SET_BLOCKDATA: {
      const key = `block-${action.blockId}`;
      let newState = state;

      Immutable.fromJS(action.changes).forEach((data, fieldname) => {
        newState = newState.setIn([key, fieldname], data);
      });

      return newState;
    }

    // Replaces block.setupData
    // TODO: doesn't seem to work
    case SET_SETUPDATA: {
      const key = `block-${action.blockID}`;
      let newState = state;

      newState = newState.setIn(
        [key, 'setupData'],
        Immutable.fromJS(action.setupData)
      );

      if (action.timestamp) {
        newState = newState.setIn([key, 'timeLoaded'], action.timestamp);
        // TODO:
        //         newState = newState.setIn([key, 'timeSetupDataLoaded'], action.timestamp);
      }

      return newState;
    }
    // Updates block.setupData
    case UPDATE_SETUPDATA: {
      const key = `block-${action.blockID}`;

      return state.mergeIn(
        [key, 'setupData'],
        Immutable.fromJS(action.setupData)
      );
    }
    // Replaces block.userData
    case SET_USERDATA: {
      const key = `block-${action.blockID}`;

      let newState = state.setIn(
        [key, 'userData'],
        Immutable.fromJS(action.userData)
      );

      if (action.timestamp) {
        newState = newState.setIn(
          [key, 'timeLoadedUserState'],
          action.timestamp
        );
      }

      return newState;
    }
    case DELETE_BLOCKS: {
      let newState = state;

      action.blockIds.forEach((blockId) => {
        newState = newState.remove(`block-${blockId}`);
      });

      return newState;
    }

    case MOVE_BLOCK_START: {
      const { draggedBlock, positionSetupData } = action;
      const key = `block-${draggedBlock.get('id')}`;

      return state.mergeIn(
        [key, 'setupData'],
        Immutable.fromJS(positionSetupData)
      );
    }
    default:
      return state;
  }
}
